<template>
	<div
		class="crowdx-whitepaper-section"
		:class="{ 'has-bgimage': backgroundImage }"
		:style="
			backgroundImage
				? `--backgroundImage: url(${backgroundImage}); --mobileBackgroundImage: url(${
						mobileBackgroundImage || backgroundImage
				  })`
				: ''
		"
	>
		<div class="background-decoration"></div>
		<img
			src="/images/sections/crowdx/crowd_logo2.svg"
			alt="CrowdX Logo"
			class="crowd-logo"
		/>
		<div class="container">
			<!-- Top section -->
			<div class="row align-items-center top-section">
				<div class="col-lg-8">
					<div class="top-text-row">
						<span class="top-text text-l first-section">{{
							$t('crowdxScreen.whitepaper.topTextFirstSection')
						}}</span>
						<span class="top-text text-l">{{
							$t('crowdxScreen.whitepaper.topText')
						}}</span>
					</div>
				</div>
				<div class="col-lg-4">
					<div class="button-wrapper">
						<base-button
							class="whitepaper-button"
							:text="$t('crowdxScreen.whitepaper.button')"
							size="large"
							type="light"
							@clicked="handleButtonClick()"
						/>
					</div>
				</div>
			</div>
		</div>
		<!-- Divider -->
		<div class="divider"></div>
		<div class="container">
			<!-- Bottom section -->
			<div class="row bottom-section">
				<div class="col-12">
					<div class="content-wrapper">
						<h1 class="main-title headline-l">
							{{ $t('crowdxScreen.whitepaper.title') }}
						</h1>
						<div
							class="description text-l"
							v-html="$t('crowdxScreen.whitepaper.description')"
						></div>
						<br />
						<div
							class="bottom-description"
							v-html="$t('crowdxScreen.whitepaper.bottomDescription')"
						></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CrowdxWhitePaper',
	props: {
		backgroundImage: {
			type: String,
			required: false,
			default: '/images/sections/crowdx/crowdX--white-paper-background.jpg',
		},
		mobileBackgroundImage: {
			type: String,
			required: false,
		},
	},
	components: {},
	data: () => ({}),
	created() {},
	computed: {},
	methods: {
		handleButtonClick() {
			window.open('https://data.blockben.com/whitepaper/crowdx.pdf', '_blank');
		},
	},
};
</script>

<style lang="scss" scoped>
.crowdx-whitepaper-section {
	position: relative;
	background: linear-gradient(99.29deg, #ce2328 5.54%, #ed8532 94.06%);

	padding-top: 60px;
	padding-bottom: 100px;
	margin: 0;
	overflow: hidden;
	min-height: 603px;

	&.has-bgimage {
		background-image: var(--backgroundImage);
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;

		@media (max-width: $breakpoint-sm) {
			background-image: var(--mobileBackgroundImage);
		}
	}

	@media (max-width: $breakpoint-sm) {
		padding: 60px 0;
	}

	.background-decoration {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		z-index: 0;
	}

	.crowd-logo {
		position: absolute;
		bottom: 48px;
		left: 185px;
		max-height: 531px;
		z-index: 1;

		@media (max-width: $breakpoint-md) {
			max-height: 490px;
		}

		@media (max-width: $breakpoint-sm) {
			max-height: 446px;
		}
	}

	.container {
		position: relative;
		z-index: 1;
	}

	.top-section {
		margin-bottom: 75px;
		flex-wrap: nowrap;

		@media (max-width: $breakpoint-lg) {
			margin-bottom: 60px;
		}

		@media (max-width: $breakpoint-sm) {
			flex-wrap: wrap;
		}
	}

	.top-text-row {
		white-space: normal;
		max-width: 630px;
	}

	.top-text {
		display: inline;
		margin-right: 2px;
	}

	.first-section {
		font-family: 'HKNova-Bold', sans-serif;
	}

	.divider {
		width: 100%;
		height: 1px;
		background-color: rgba(255, 255, 255, 1);
		margin-bottom: 60px;

		@media (max-width: $breakpoint-lg) {
			margin-bottom: 40px;
		}
	}

	.bottom-section {
		.content-wrapper {
			text-align: right;

			@media (max-width: $breakpoint-sm) {
				text-align: center;
			}
		}
	}

	.top-text {
		color: #ffffff;
		line-height: 24px;

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
		}

		@media (max-width: $breakpoint-sm) {
			text-align: center;
			margin-bottom: 30px;
		}
	}

	.main-title {
		color: #ffffff;
		margin-bottom: 20px;
		text-transform: uppercase;

		@media (max-width: $breakpoint-sm) {
			margin-bottom: 30px;
		}

		@media (max-width: $breakpoint-xs) {
			font-size: 32px;
		}
	}

	.description {
		color: #ffffff;
		line-height: 24px;
		max-width: 590px;
		margin-left: auto;
		font-family: 'HKNova-Light', sans-serif;

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
		}

		@media (max-width: $breakpoint-sm) {
			margin-left: auto;
			margin-right: auto;
		}
	}

	.bottom-description {
		color: #ffffff;
		line-height: 24px;
		max-width: 390px;
		margin-left: auto;
		font-family: 'HKNova-Bold', sans-serif;

		@media (max-width: $breakpoint-sm) {
			font-size: 16px;
		}

		@media (max-width: $breakpoint-sm) {
			margin-left: auto;
			margin-right: auto;
		}
	}

	.button-wrapper {
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;

		@media (max-width: $breakpoint-lg) {
			justify-content: center;
		}

		.whitepaper-button {
			min-width: 255px;
			text-transform: unset;

			@media (max-width: $breakpoint-sm) {
				width: 100%;
				margin-top: 30px;
			}

			&::v-deep {
				.button-label {
					font-family: 'HKNova-Bold', sans-serif;
					text-transform: capitalize;
				}
			}
		}
	}
}
</style>
